import React from 'react';
import { METRICS, PERIODS } from '../../utils/analyticsUtils';

const ComparisonControls = ({
  selectedMetric,
  onMetricChange,
  selectedPeriod,
  onPeriodChange,
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6 p-4 bg-gray-50 rounded-lg border">
      {/* Metric Selector */}
      <div className="flex-1">
        <label htmlFor="metric-select" className="block text-sm font-medium text-gray-700 mb-1">
          Metric
        </label>
        <select
          id="metric-select"
          value={selectedMetric}
          onChange={(e) => onMetricChange(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        >
          {Object.values(METRICS).map(metric => (
            <option key={metric.key} value={metric.key}>
              {metric.name}
            </option>
          ))}
        </select>
      </div>

      {/* Period Selector */}
      <div className="flex-1">
        <label htmlFor="period-select" className="block text-sm font-medium text-gray-700 mb-1">
          Period
        </label>
        <select
          id="period-select"
          value={selectedPeriod}
          onChange={(e) => onPeriodChange(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        >
          {Object.values(PERIODS).map(period => (
            <option key={period.key} value={period.key}>
              {period.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ComparisonControls;